import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, AfterContentChecked, SimpleChanges } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { InfoBoxComponent } from '../../utility/info-box/info-box.component';
import { AppointmentStepperService } from '../../../services/appointment-stepper.service';
import { AccountDataDTO, RelatedProfileDTO, UserAccountDTO, UsersAccountDTO } from '../../../classes/user-account.dto';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { StorageService } from '../../../services/storage.service';
import { DataService } from '../../../services/data.service';
import { HttpService } from '../../../services/http.service';
import { Router } from '@angular/router';
import { ModalCreateProfileComponent } from '../../modals/modal-create-profile/modal-create-profile.component';
import { CommonModule } from '@angular/common';
import { ConsultTypeService } from '../../../services/consult-type.service';

@Component({
  selector: 'app-profile-selection',
  standalone: true,
  imports: [CommonModule, NzRadioModule, ReactiveFormsModule, NzDividerModule, NzIconModule, TranslateModule, InfoBoxComponent],
  templateUrl: './profile-selection.component.html',
  styleUrl: './profile-selection.component.scss',
})
export class ProfileSelectionComponent implements OnInit, AfterContentChecked, OnDestroy {
  @Input({ required: true }) profiles: any;
  @Input() vet?: boolean = false;
  @Input() typeAppointment: string = '';
  @Input() modeSelection?: boolean = false;
  @Output() profileEmitter: EventEmitter<UsersAccountDTO | RelatedProfileDTO> = new EventEmitter<UsersAccountDTO | RelatedProfileDTO>();
  @Output() profileInputEmitter: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() vetEmitter: EventEmitter<string> = new EventEmitter<string>();
  activeUsers: any;
  profileSelected: FormControl<UsersAccountDTO | RelatedProfileDTO> = new FormControl();
  vetTypeSelected: FormControl<any> = new FormControl();
  subscriptions: Array<Subscription> = [];
  private destroy$ = new Subject<void>();
  isUserManagementAble: boolean = false;

  constructor(
    private appointmentStepperService: AppointmentStepperService,
    private modal: NzModalService,
    private storage: StorageService,
    private dataService: DataService,
    private http: HttpService,
    private router: Router,
    private consultTypeService: ConsultTypeService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.profileSelected.valueChanges.subscribe((profile: UsersAccountDTO | RelatedProfileDTO): void => {
        const mainUser = this.appointmentStepperService.getMainUser();
        if (mainUser?.individualId !== profile.individualId) {
          this.profileEmitter.emit(profile);
        }
      })
    );
    this.subscriptions.push(
      this.vetTypeSelected.valueChanges.subscribe((type: string) => {
      this.consultTypeService.setType(type);
      this.vetEmitter.emit(type);
      })
    );
    const oldValues = this.appointmentStepperService.getMainUser();
    if (oldValues) {
      this.profileSelected.patchValue(oldValues);
    }

    if (this.appointmentStepperService.getAppointmentType()) {
      this.vetTypeSelected.patchValue(this.appointmentStepperService.getAppointmentType());
    }

    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    this.isUserManagementAble = userData.functions ? userData.functions.includes('MPM') : false;
  }

  ngAfterContentChecked() {
    if (!this.vet) {
      this.setMainUser();
    }
  }

  private setMainUser() {
    this.activeUsers = this.profiles?.relatedProfiles?.filter((res: any) => res.isChangeProfileEnabled);
    const shouldAutoSelect = this.profiles && (this.profiles?.relatedProfiles?.length === 0 || this.activeUsers?.length === 0);
    if (shouldAutoSelect) {
      const current = this.profileSelected.value;
      if (!current || current.individualId !== this.profiles.individualId) {
      if (this.profiles && (this.profiles?.relatedProfiles?.length === 0 || this.activeUsers?.length === 0)) {
        this.profileSelected.patchValue(this.profiles, { emitEvent: false });
        this.profileEmitter.emit(this.profiles);
        }
      }
    }
  }

  protected createProfile(): void {
    const modalRef: NzModalRef<ModalCreateProfileComponent> = this.modal.create({
      nzContent: ModalCreateProfileComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          actionButton: () => {
            this.appointmentStepperService.clearUsers();
            /*            this.getUsers(); */
            this.dataService.setChangeNavbar(true);
            modalRef.close();
          },
        },
      },
    });
    modalRef.afterClose.subscribe((result): void => {
      console.log(result);
    });
  }

  protected profileSelectionInputEmitter(formData: FormGroup): void {
    this.profileInputEmitter.emit(formData);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
  }

  public switchProfile(user: any) {
    if (user) {
      const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
      const oldUserData = JSON.parse(this.storage.getItem('oldUserData')!) as UserAccountDTO;
      if (oldUserData && oldUserData.individualId === user.value.individualId) {
        this.http
          .getAccountdDataNoConnectionValidations(user?.value.individualId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((accountData: AccountDataDTO) => {
            this.dataService.setAccountDataFrom(false);
            this.storage.setItem('userData', oldUserData);
            this.dataService.setAccountData(accountData);
            this.storage.removeItem('oldUserData');
            this.router.navigate(['/personal-area/your-data']);
          });
      } else if (user.value.individualId === userData.individualId) {
        this.router.navigate(['/personal-area/your-data']);
      } else {
        this.http
          .getAccountdDataNoConnectionValidations(user?.value.individualId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((accountData: AccountDataDTO) => {
            this.dataService.setAccountData(accountData);
            this.dataService.setAccountDataFrom(true);
            const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
            var data = { ...accountData.customer };
            data.functions = accountData.functions;
            this.storage.setItem('oldUserData', userData);
            this.storage.setItem('userData', data);
            this.router.navigate(['/personal-area/your-data']);
          });
      }
    }
  }
}
